import { callApi } from "repoV2/utils/common/api/callApi";
import { appendURLSearchParams } from "repoV2/utils/urls&routing/urlParams";
import {
    CHECKOUT_PAGE_DETAILS_API_ENUMS,
    PAGE_SOURCES_VALUES,
} from "repoV2/features/CheckoutPages/constants/CheckoutPages.constants";
import { checkout_pages_api } from "../CheckoutPages.api";
import {
    ILoyaltyDiscountSectionApiResponse,
    ILoyaltyCouponDetails,
} from "./ILoyaltyDiscountSectionApi.interface";

export const callGetLoyaltyAndPromoDetailsApi = ({
    hostName,
    listingUuid,
    currencyName,
}: {
    hostName: string;
    listingUuid: string;
    currencyName: string;
}) =>
    callApi({
        url: `${
            checkout_pages_api.checkout_page_details
        }/${hostName}/${listingUuid}${appendURLSearchParams("", {
            section: `${CHECKOUT_PAGE_DETAILS_API_ENUMS.LOYALTY_AND_PROMOTIONAL_DISCOUNT_SECTION}`,
            page_source: `${PAGE_SOURCES_VALUES.CHECKOUT_PAGE}`,
            currency: currencyName,
        })}`,
        extraOptions: {
            appendExlyBackendHeaders: true,
        },
    }).then((response: ILoyaltyDiscountSectionApiResponse) => {
        const { show_loyalty, promotional_coupons } =
            response?.data?.data?.[
                CHECKOUT_PAGE_DETAILS_API_ENUMS
                    .LOYALTY_AND_PROMOTIONAL_DISCOUNT_SECTION
            ] || {};

        return {
            show_loyalty,
            promotional_coupons,
        };
    });

export const callGetLoyaltyListApi = async ({
    email,
    listingUuid,
    currency,
}: {
    email: string;
    listingUuid: string;
    currency: string;
}) =>
    callApi({
        url: `${checkout_pages_api.get_loyalty_list}${appendURLSearchParams(
            "",
            {
                customer_email: email,
                listing_uid: listingUuid,
                currency,
            }
        )}`,
        extraOptions: {
            appendExlyBackendHeaders: true,
        },
    }).then(response => {
        const loyaltyList: ILoyaltyCouponDetails[] =
            response?.data?.data?.order || [];
        return loyaltyList;
    });
